import { useEffect, useState } from 'react';
import { ThreeCirclesLoading } from '../hoc/threeCirclesLoading';
import parse from 'html-react-parser';
import { ProcessedLessonWidgetTextMath } from '../../helpers/processedLessonWidgetTextMath';
import Aux from '../hoc/auxiliary'


export const StandardsSubMapping = ({ detail, clickDetail, activeDetail, resourcesFromDb, coverageAcceptance}) => {

  const [results, setResults] = useState(false)
  const [ generatingDetail, setGeneratingDetail ] = useState(false)


  useEffect(() => {

    if(detail && resourcesFromDb){

      if(detail.resources){

    const resultList = detail.resources.map(r => {

      const res = {
        id: `res_${r.id}`,
        title: r.description,
        url: r.url,
        resourceFormat: r.resourceFormatId === 414 ? 'video' : 'pdf',
        score: r.score1,
        completionLevel: r.score2,
        completionExplanation: r.explanation,

      }

      return res
    })

    setResults(resultList)
  } else {
    setResults([])
  }
  }



  }, [detail, resourcesFromDb])



  // const handleSearchCount = async () => {
  //   try {

  //    setGeneratingDetail(true)

  

  //    let subjectsList = []
  //    let yearsList = []
  //     if(standard){
  //    standard.listOfSubjects.forEach(s => {
  //     subjectsList.push(s.description.trim().split(" ").map(su => su.toLowerCase()).join("-"))
  //    })

  //    standard.listOfYearNumbers.forEach(s => {
  //     yearsList.push(s.description.trim().split(" ").map(su => su.toLowerCase()).join("-"))
  //    })
  //   }


  //    const bodyToSend = {
  //     subjectsFilter: subjectsList,
  //     yearGroupsFilter: yearsList,
  //     filterPublishers: publisherFilter.title,
  //     searchQuery: originalDetail.description,
  //     gptDemo: demo && publisherFilter.demo && publisherFilter.demo.find(d => d === demo) ? demo : null,
  //     vectorAcceptance,
  //     subObjective: detail.description,
  //     subObjectiveType: detail.type,
  //     clarificationStatement

  //    }
  
  //    // make a POST call to our api route
  //    let res = await fetch('/api/search', {
  //     method: 'POST',
  //     headers: {
  //      'Content-type': 'application/json',
  //     },
  //     body: JSON.stringify(bodyToSend)
    
  //    })
  
  //    if (res.ok) {
  //     const json = await res.json();
  //     // https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/getReader
  //     if(json && json.results){

  //         setResults(json.results)
  //         console.log("json", json.results)

  //     setGeneratingDetail(false)
  //     // const sectionIndex = parseInt(index.split("-")[0])
  //     // const detailIndex = parseInt(index.split("-")[1])
  //     // const goToNextIndex = detailIndex + 1 === detailLength
  //     // const newSectionIndex = goToNextIndex ? sectionIndex + 1 : sectionIndex
  //     // const newDetailIndex = goToNextIndex ? 0 : detailIndex + 1
  //     // setIndexFound(`${newSectionIndex}-${newDetailIndex}`)

  //     if(resourcesFromDb){

  //       const resultsArray = json.results.map(r =>{

  //         const rId = parseInt(r.id.split("_")[1],10)
  //         // const rId = Math.round(Math. random() * (24200 - 24100) + 24100)

  //         const result = {
  //             resourceId: rId,
  //             curriculumSubObjectiveId: detail.id,
  //             score1: r.score,
  //             score2: parseFloat(r.completionLevel),
  //             explanation: r.completionExplanation
  //         }

  //         return result
  //       })


  //       const apiBaseUrl = `${config.apiUrl}CognitiveSearch/AddOrUpdateSubObjectiveMapping/${parseInt(publisherFilter.userId,10)}`;
  //       axios.post(apiBaseUrl, resultsArray, {
  //           headers: authHeader(),
  //       }).then(response => {
            
  //           console.log("done", response)
            
  //       }).catch(function (error) {
  //           console.log('Looks like there was a problem: \n', error);
         
  //       });
        

  //     }



  //     // if(index === finalIndex){
  //     //   setRefreshDataLoading(false)
  //     // }
      
  //    }
  //   }
   
  
  //     else {
  //     alert(`error getting response`)
  //     setGeneratingDetail(false)
  //    }
  //   } catch (error) {
  //    alert(`error: ${error.message}`)
  //    setGeneratingDetail(false)
  //   }
  // }

  const completionToColor = (score) => {

    const colorArray = ["#FF0000", "#FF8A00", "#FFF500", "#9EFF00", "#61FF00", "#00FF47", "#00FF94", "#00ffbb", "#00ffd0", "#00ffe5"]

    const normalisedScore = Math.round(parseInt(score*5,10))

    if(normalisedScore >= 10){
        return "#2291E1"
      } else {
        return colorArray[normalisedScore]
      }


  }




    return (

      <Aux>
        {detail.type !== 'Clarification Statement' && detail.type !== 'Assessment Boundary' &&
            <div style={{width: '100%', padding: '0.8rem', backgroundColor: detail.type === 'Science and Engineering Practices' ? '#5994E3' : detail.type === 'Disciplinary Core Ideas' ? '#EC863D' : detail.type === 'Crosscutting Concepts' ? '#539E4C' : '#FFFFFF'}} className="ai-body-small bold ai-grey-100">{detail.type}</div>
        }
        <div className={generatingDetail ? 'gpt-standards__detail gpt-standards__detail--loading' : activeDetail && activeDetail.id === detail.id ?  'gpt-standards__detail gpt-standards__detail--active' :  'gpt-standards__detail'} onClick={() => clickDetail(detail, results)}>
          <div style={{display: 'flex', alignItems: 'center', gap: '1.2rem'}}>

            {detail.type === 'Clarification Statement' || detail.type === 'Assessment Boundary' ?
              <div>
              <span className="ai-body-small bold ai-grey-100">{`${detail.title}: `}</span>
              <span className="ai-body-small ai-grey-100">{detail.description}</span>
              </div>
            :
            detail.type
            ?
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.4rem'}}>

              <div className="ai-body-small bold ai-grey-100">{`${detail.code} ${detail.title}`}</div>
              <div className="ai-body-small ai-grey-100">{detail.description}</div>

            </div>
            :
            <ProcessedLessonWidgetTextMath customClass={'ai-body-small ai-grey-100'} text={detail.code ? `${parse(detail.title)}: ${parse(detail.description)} (${detail.code})` : `${parse(detail.title)}: ${parse(detail.description)}`} />
            }

          </div>

            {detail.type !== 'Clarification Statement' && detail.type !== 'Assessment Boundary' &&
            <ThreeCirclesLoading loading={generatingDetail} size={20} color={'#000000'}>
              <div className="gpt-standards__detail--score">
              {/* {(isStaging && (user.id === 6795 || user.id === 4254)) && <button onClick={() => handleSearchCount()}>Refresh</button>} */}
              {results && !generatingDetail && <div className="ai-body-small ai-grey-100" style={{backgroundColor: '#FFFFFF', borderColor: '#000000', borderWidth: '1px', borderStyle: 'solid'}}>{`${results.length}`}</div>}
              {results && !generatingDetail && <div className="ai-body-small bold ai-grey-100" style={{backgroundColor: '#FFFFFF', borderWidth: '2px', borderStyle: 'solid', borderColor: completionToColor(coverageAcceptance)}}>{`${results.filter(r => parseFloat(r.completionLevel) >= coverageAcceptance).length}`}</div>}
              </div>
              
            </ThreeCirclesLoading>
            }
            {(generatingDetail) && <div className="gpt-standards__loading"></div>}
        </div>

        </Aux>
    
          
    );
};